export const telegramChatModalName = 'telegram-chat';
